import(/* webpackMode: "eager" */ "/app/apps/teacher/src/app/error.tsx");
